import { MemberStatus } from '@/modules/team';

/**
 * Team member statuses to include when filtering in the assignment modal
 * Includes all active and manageable member states
 */
export const ASSIGNMENT_TEAM_MEMBER_FILTER_STATUSES = [
  MemberStatus.Active,
  MemberStatus.Basic,
  MemberStatus.Invited,
  MemberStatus.Placeholder,
  MemberStatus.Expired,
] as const;
